import React from "react";
import { X } from "react-feather";
import type { PdfMergePanelTab } from "./types";

export interface PanelChromeProps {
  title: string;
  closeLabel: string;
  onClose?: () => void;
  tabs: PdfMergePanelTab[];
  activeTab: string;
  onSelectTab: (tabId: string) => void;
  onTabKeyDown: (
    event: React.KeyboardEvent<HTMLButtonElement>,
    index: number,
  ) => void;
}

export function PanelChrome({
  title,
  closeLabel,
  onClose,
  tabs,
  activeTab,
  onSelectTab,
  onTabKeyDown,
}: PanelChromeProps) {
  return (
    <>
      <header className="pdf-merge-panel__header">
        <div className="pdf-merge-panel__heading">{title}</div>
        {onClose && (
          <button
            type="button"
            className="pdf-merge-panel__close"
            aria-label={closeLabel}
            title={closeLabel}
            onClick={onClose}
          >
            <X size={20} aria-hidden="true" />
          </button>
        )}
      </header>
      {tabs.length > 0 && (
        <div
          className="pdf-merge-panel__tab-bar"
          role="tablist"
          aria-label={title}
        >
          {tabs.map((tab, index) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={tab.id === activeTab}
              tabIndex={tab.id === activeTab ? 0 : -1}
              className={[
                "pdf-merge-panel__tab",
                tab.id === activeTab && "pdf-merge-panel__tab--active",
              ]
                .filter(Boolean)
                .join(" ")}
              disabled={tab.disabled}
              onClick={() => onSelectTab(tab.id)}
              onKeyDown={(event) => onTabKeyDown(event, index)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
    </>
  );
}
